import { hexConcat, hexZeroPad } from 'ethers/lib/utils';

export const createCompactSignature = (r: any, s: any, v: any) => {
    // v 값을 1바이트로 변환
    const vHex = hexZeroPad(`0x${v.toString(16)}`, 1);

    // r + s + v 를 concat해서 compact signature 생성
    const signature = hexConcat([r, s, vHex]);
    console.log('!! compact : ', signature);
    return signature;
};
